import React from "react";
import { BUSINESS_OPTIONS } from "../consts";
import "../scss/lineOfBusiness.scss"
import { clearCookieKeys, encryptValue, saveInLocalStorage, viewModeOn } from "../utilFunctions";
import { menuItems } from "../dashboard/sidemenu";
import { useNavigate } from "react-router-dom";

const LineOfBusiness = ({onChange}) => {

    const navigate = useNavigate();
    
    const getMenuItemsToShow = (business) => {
        return menuItems.filter(item => viewModeOn(item.key) && (item.business || []).includes(business));
    }

    const onSelectBusiness = (business) => {
        saveInLocalStorage("lineOfBusiness", encryptValue(business))
        let menuItemsToShow = getMenuItemsToShow(business)
        if(onChange) {
            onChange(business);
        }
        if (menuItemsToShow && menuItemsToShow.length) {
            navigate(`/dashboard/${menuItemsToShow[0].page}`)
        } else {
            // clearCookieKeys();
            // instance.logoutRedirect()
        }
    }
    
  return (
    <div className="line-of-business-selector container-fluid">
      <div className="content-wrapper">
        <div className="cms-text row">
          <div className="col-12">
            <p>Claim Management System</p>
          </div>
        </div>

        <div className="lob-text row mb-2">
          <div className="col-12">
            <p>Select your Line of Business</p>
          </div>
        </div>

        <div className="business-options row">
          {BUSINESS_OPTIONS.map((option) => (
            <div
              key={option.key}
              className="business-card col-12 col-md-6 col-lg-4 mb-3"
              onClick={() => onSelectBusiness(option.key)}
            >
              <div className="hover-text">OPEN</div>
              <img
                src={option.icon}
                alt={`${option.name} icon`}
                className="icon me-2"
              />
              <div className="name">{option.name}</div>
              {option.label && <div className="label">{option.label}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LineOfBusiness;
